import { Menu } from '@base-ui/react';
import { useEffect, useState } from 'react';

import { Icon } from '~/components';

import { groupLabelStyle, groupStyle, itemStyle, popupStyle, positionerStyle, shortcutStyle, triggerStyle } from './CommandMenu.css';
import { useCommandMenuContext } from './CommandMenuProvider.context';

const CommandMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { menuItems } = useCommandMenuContext();

  useEffect(() => {
    const onKeydown = (e: KeyboardEvent) => {
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setIsOpen((isOpen) => !isOpen);
      }
    };

    document.addEventListener('keydown', onKeydown);
    return () => document.removeEventListener('keydown', onKeydown);
  }, []);

  const menuGroups = Object.entries(Object.groupBy(menuItems, ({ group }) => group));

  if (menuGroups.length === 0) return null;

  return (
    <Menu.Root modal={false} onOpenChange={setIsOpen} open={isOpen}>
      <Menu.Trigger aria-label="Dev menu" className={triggerStyle}>
        <Icon name="DataObject" size={16} />
      </Menu.Trigger>

      <Menu.Portal>
        <Menu.Positioner align="start" className={positionerStyle} sideOffset={4}>
          <Menu.Popup className={popupStyle}>
            {menuGroups.map(([group, menuItems]) => (
              <Menu.Group className={groupStyle} key={group}>
                <Menu.GroupLabel className={groupLabelStyle}>{group}</Menu.GroupLabel>
                {(menuItems ?? []).map((menuItem) => (
                  <Menu.Item className={itemStyle} key={menuItem.id} label={menuItem.shortcut ?? menuItem.label} onClick={menuItem.onClick}>
                    {menuItem.label}
                    {menuItem.shortcut && <kbd className={shortcutStyle}>{menuItem.shortcut}</kbd>}
                  </Menu.Item>
                ))}
              </Menu.Group>
            ))}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
};

export default CommandMenu;
